import { render, staticRenderFns } from "./InputOutingNeedsMealTable.vue?vue&type=template&id=284eb474&lang=pug"
import script from "./InputOutingNeedsMealTable.vue?vue&type=script&lang=ts"
export * from "./InputOutingNeedsMealTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports